import utils from 'utils'
class refundServiceChargeTaskTrackCtrl {
  constructor(
    $scope,
    logger,
    httpRequest,
    initSortService,
    $timeout,
    sweetalert,
    $uibModal,
    RSCTT_fieldConfig
  ) {
    // 列表查询字段设置
    $scope.customizedConfig = RSCTT_fieldConfig
    // 所勾选初始的数据
    $scope.selectedRows = []
    // 改变税款所属月份
    $scope.updateSearch = function () {
      queryInfo()
    }
    $scope.select = {}
    $scope.params = {
        pageSize: 2000,
        pageNum: 1,
        param: {
          isRoleOwner: '1', // 拥有本机构角色
          orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
        },
      }
    $scope.currentUserInfo = JSON.parse(localStorage.user_info).user
    $scope.treeConfig = {
        isCheckall: true,
        check: {
            //如果没有设置配置项，取默认配置
            enable: true, //显示不显示复选框
            chkboxType: { Y: '', N: '' },
        },
    }
    $scope.queryParam = {
      pageNum: 1,
      pageSize: 10,
      param: {
        taxPeriod: new Date().getFullYear() - 1, // 时间
      },
    }
    $scope.datePickerConfig = {
      format: 'yyyy',
      startView: 'decade',
      minView: 'decade',
    }
    // 字典数据
    $scope.dictData = {}
    const typecodeArr = ['department_no', 'gs_refundStatus']
    httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
      $scope.dictData = $.extend($scope.dictData, res.data.value)
    })
    // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
    httpRequest.get_getBelleRegion().then((res) => {
      $scope.belleRegionList = res.data.value
    })
    // 联动查询管理城市
    $scope.linkageQuery = function (enumName) {
      let departmenNoObj = $scope.dictData.department_no.find((v) => {
        if (v.enumName === enumName) {
          return v.enumCode
        }
      })
      let belleRegionListObj = $scope.belleRegionList.find((v) => {
        if (v.regionName === enumName) {
          return v.regionNo
        }
      })
      if (departmenNoObj) {
        $scope.departmentNo = departmenNoObj.enumCode
      }
      if (belleRegionListObj) {
        $scope.regionNo = belleRegionListObj.treeLevelCode
      }
      let params = {
        affiliation: $scope.departmentNo,
        regionNo: $scope.regionNo,
      }
      if (params.affiliation == '' || params.regionNo == '') return
      httpRequest.get_getBelleRegion(params).then((res) => {
        $scope.belleRegionCityList = res.data.value
      })
    }
    // 获取所有主管税局信息
    httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
      $scope.dictDataProvince = res.data.value
    })
    function getUsersInfo() {
        httpRequest.get_getIvatEmployeeList().then((res) => {
            $scope.followerList = dataHandle(res.data.value)
            $scope.select.selectedFollower =  $scope.followerList.filter((x) => { return x.employeeName == $scope.currentUserInfo.realName})
            queryInfo()
          })
    }
    getUsersInfo()
    function dataHandle(list) {
        list.forEach((el,index) => {
            el.orgId = index
            el.orgName = el.employeeName + '|' + el.employeeNumber
            if ($scope.currentUserInfo.realName == el.employeeName) {
                el.checked = true
            } else {
                el.checked = false
            }
        })
        return list
    }
    // 重置
    $scope.reset = function () {
      $scope.queryParam = {
        pageNum: 1,
        pageSize: 10,
        param: {
          taxPeriod: new Date().getFullYear() - 1, // 时间
        },
      }
      $scope.belleRegionCityList = []
      getUsersInfo()
    }

    $scope.pageChanged = function () {
      // 点击页码发起查询
      queryInfo()
    }

    function queryInfo() {
      const openLoading =
        $scope.queryParam.pageSize >= 100
          ? window.layer.msg('正在查询，请耐心等待', {
              time: 0,
              skin: 'layer-loading-self',
              icon: 16,
              shade: 0.5,
            })
          : null
      httpRequest
        .post_getRpaGsRefundTaskList(queryDataHandle($scope.queryParam))
        .then((res) => {
          $scope.listData = res.data.value.list
          // 获取后台分页数据 回写分页组件
          $scope.totalItems = res.data.value.total
          $scope.queryParam.pageNum = res.data.value.pageNum
          $scope.queryParam.pageSize = res.data.value.pageSize
        })
        .finally(() => {
          window.layer.close(openLoading)
        })
    }
    function queryDataHandle(queryData) {
        $scope.employeeList = []
        const { selectedFollower } = $scope.select
        selectedFollower.forEach(item => {
            $scope.employeeList.push({employeeName:item.employeeName, employeeNumber:item.employeeNumber})
        });
        queryData.param.employeeList = $scope.employeeList
        return queryData
    }
    $scope.searchList = function () {
      queryInfo()
    }
    $scope.tableDropdownConfig = [
      {
        label: '申请退付手续费',
        handler(item) {
          $scope.applyForRefundToPayFees([item])
        },
        showWhile(item, hasPermit) {
          return hasPermit('apply_for_refund_pay_fees')
        },
      },
      {
        label: '还原',
        handler(item) {
          $scope.reduction([item])
        },
        showWhile(item, hasPermit) {
          return hasPermit('apply_for_refund_reduction')
        },
      },
    ]
    // 导出
    $scope.exportExel = function exportExel() {
      let fileName = '退付手续费任务跟踪(个人所得税)_' + $scope.queryParam.param.taxPeriod
      let _url = `${
        host.etcloudIvatApp
      }taxdeclaration/rpaGsRefundTask/exportList?accessToken=${localStorage.getItem('id_token')}`
      utils.file_download(
        _url,
        $scope.queryParam.param,
        '', //type
        'POST',
        'blob',
        fileName,
        false
      )
    }
    $scope.applyForRefundToPayFees = function (listData) {
      const idList = listData.map((el) => el.id)
      if (!idList.length) return logger.logError('请选择数据后操作！')
      httpRequest.post_doRpaGsRefund(idList, '申请退付手续费成功').then((res) => {
        queryInfo()
      })
    }
    $scope.reduction = function (listData) {
      const idList = listData.map((el) => el.id)
      if (!idList.length) return logger.logError('请选择数据后操作！')
      const checkStatus = listData.some(
        (el) => el.refundStatus == 0 || el.refundStatus == 2 || el.refundStatus == 3
      )
      if (checkStatus)
        return logger.logError(
          '仅退付手续费状态为待RPA申请和申请失败的数据允许还原退付手续费状态，请检查。'
        )
      sweetalert
        .confirm(
          '还原提醒',
          '确认需要对选择的数据进行还原操作，确认请点击【确定】按钮，否则点击【取消】按钮。'
        )
        .then(() => {
          httpRequest.post_reductionRpaGsRefundStatus(idList, '还原成功').then((res) => {
            queryInfo()
          })
        })
    }
    $scope.manuallyGenerated = function () {
      httpRequest.get_buildRpaGsRefundTask().then((res) => {
        logger.logSuccess('手工生成成功！')
        queryInfo()
      })
    }
  }
}
refundServiceChargeTaskTrackCtrl.$inject = [
  '$scope',
  'logger',
  'httpRequest',
  'initSortService',
  '$timeout',
  'sweetalert',
  '$uibModal',
  'RSCTT_fieldConfig',
]
export default refundServiceChargeTaskTrackCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/refundServiceChargeTaskTracking/refundServiceChargeTaskTrackCtrl.js